import React, { useContext, useState } from "react";
import getRequestSubjectService from "../../Service/RequestSubject/RequestSubject.ts";

const mainContext = React.createContext();

export function MainContext() {
  return useContext(mainContext);
}

export function MainContextProvider({ children }) {
  const [userRole, setUserRole] = useState("");
  const setRole = async (user) => {
    setUserRole(user);
    return;
  };

  const [requestSubject, setRequestSubject] = useState([]);
  const getRequestSubject = async () => {
    await getRequestSubjectService().then((value) => {
      setRequestSubject(value?.data);
    });
    return;
  };

  return (
    <mainContext.Provider
      value={{
        requestSubjectList: requestSubject,
        requestSubjectListFunction: getRequestSubject,
        userRoleValue: userRole,
        setUserRole: setRole,
      }}
    >
      {children}
    </mainContext.Provider>
  );
}
